import PreEventTopMetrics from './pre-event-top-metrics-container';

export default PreEventTopMetrics;
